import HomeIcon from '@mui/icons-material/Home';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { MenuItems } from './interfaces';

const menuItemsInspector: MenuItems[] = [
    {
        heading: '',
        items: [
            {
                name: 'Home',
                icon: HomeIcon,
                link: '/inspector/dashboard'
            },
            {
                name: 'Events',
                icon: EventAvailableIcon,
                link: '/inspector/events'
            },
            {
                name: 'Reports',
                icon: AssessmentIcon,
                link: '/inspector/reports'
            },

        ]
    }
];

export default menuItemsInspector;
